
export default function (Component) {
  Component.options.__source = "src/components/aboutForm/billingInfo.vue"
}
